module.exports = require('./helpers/bundle-url').getBundleURL('a0IFD') + "pdf.worker.min.a68f1388.js";